module.exports = __webpack_public_path__ + "static/media/icone_maritime.9417d956.jpg";